var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.029,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1C6.372 1 1 6.373 1 13s5.372 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "m14.005 12.276 4.956-5.637h-1.174l-4.305 4.893-3.436-4.893H6.082l5.197 7.4-5.197 5.911h1.174l4.543-5.169 3.63 5.17h3.964zm-1.609 1.828-.527-.737-4.19-5.862h1.804l3.382 4.732.525.738 4.396 6.151h-1.804z"
  })));
};
export default SvgTwitter;